import { showError } from './fieldvalidation';

const form = $('.apo-form form');

const emailSend = form.find('input[name="emailSend"]');
emailSend.each(function() {
  $(this).hide();
});

form.submit(function (event) {
  const $this = $(this);
  const button = $this.find('button[type="submit"]');
  $(button).prop('disabled', true);
  setTimeout(function(){
    $(button).prop('disabled', false)
  }, 5000);

  $this
    .find('input, textarea, select')
    .each(function () {
      const formField = $(this).closest('.form-field');
      const errorMessageMissing = formField.find('.error-message--missing');
      const errorMessageInvalid = formField.find('.error-message--invalid');
      showError(this, formField, errorMessageMissing, errorMessageInvalid);
      if (!this.validity.valid) {
        event.preventDefault();
      }
    });
});
